export const calcCompletedHours = (estimated, percent) => {
	return Math.floor((percent/100)*estimated)
}

export const renderOverAllocation = ( calcOverAllocation ) => {
	let result = Math.abs(calcOverAllocation);
  return isNaN(result) ? 0 : result;
}

export const calcOverAllocation = (completedHrs, sumTotalHrs) => {
	return Math.floor(completedHrs - sumTotalHrs);
}

export const sumTotalHrs = ( transferredTotal, weeklySum ) => {
    return transferredTotal + weeklySum;
}



// WEBPACK FOOTER //
// ./src/App/Util/overAllocation.js